import { render } from "./HeroiconsOutlineQrcode.vue?vue&type=template&id=1fa0c7c0"
const script = {}

import exportComponent from "/home/nginx/domains/panel.vip-mod.net/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineQrcode.vue"]])

export default __exports__